import {
  SET_DESIGN_IMPORT_RECORD,
  RESET_DESIGN_IMPORT_DATA,
  DESIGN_IMPORT_ACTION_START,
  DESIGN_IMPORT_ACTION_FAILURE,
} from 'actions/designImport';

const initialState = {
  isLoading: false,
  message: '',
  data: {},
};

const actionsMap = {
  [SET_DESIGN_IMPORT_RECORD]: (state, action) => {
    return {
      ...state,
      data: action.data,
      isLoading: false,
    };
  },
  [DESIGN_IMPORT_ACTION_START]: (state) => {
    return {
      ...state,
      isLoading: true,
      message: '',
    };
  },
  [DESIGN_IMPORT_ACTION_FAILURE]: (state, action) => {
    return {
      ...state,
      isLoading: false,
      message: action.data,
    };
  },
  [RESET_DESIGN_IMPORT_DATA]: () => initialState,
};

export default function designImport(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}
